import {
  GzAutomaticActionSettingsWebComponent,
} from '../../automaticActionSettings/component/GzAutomaticActionSettingsWebComponent';
import { ScanSettings, ScanType } from '../../../types';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { html, TemplateResult } from 'lit';
import { FontSizes } from '../../../../../../../types/common/types';
import { GzRadioGroupWebComponent } from '../../../../../../../ui/gzRadio';
import { customElement, query } from 'lit/decorators.js';

@customElement('gz-scan-automatic-action-settings')
export class GzScanAutomaticActionSettingsWebComponent extends GzAutomaticActionSettingsWebComponent<ScanSettings> {
  @query('#scan-types')
  private scanTypesRadioGroup: GzRadioGroupWebComponent;

  protected getTitle(): string {
    return translateFn('Edit scan configuration');
  }

  protected getDescription(): string {
    return translateFn('Run an on-demand scan on the endpoint where the detection took place.');
  }

  protected renderContent(): TemplateResult {
    return html`
      <gz-labeled-content
        class="mt-3"
        label=${translateFn('Scan type')}
        labelFontSize="${FontSizes.PARAGRAPH_13}"
        hasColon
      >
        <gz-radio-group id="scan-types" selectedOption="${this.settings.type}">
          <gz-radio label="${translateFn('Quick')}" value="${ScanType.QUICK}"></gz-radio>
          <gz-radio label="${translateFn('Full')}" value="${ScanType.FULL}"></gz-radio>
        </gz-radio-group>
      </gz-labeled-content>
    `;
  }

  protected editAction(): void {
    this.settings.type = Number(this.scanTypesRadioGroup.getFormValue());
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-scan-automatic-action-settings': GzScanAutomaticActionSettingsWebComponent;
  }
}
